const platform = {};

platform.ismobile = (function(){
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      return true
  }else{
    return false
  }
})()

platform.isiphone = (function(){
  if( /iPhone|iPad|iPod/i.test(navigator.userAgent) ) {
      return true
  }else{
    return false
  }
})()

export default platform;
